// extracted by mini-css-extract-plugin
export var image = "provider-profile-slider-module--image--d53b0";
export var imageContainer = "provider-profile-slider-module--imageContainer--24d75";
export var info = "provider-profile-slider-module--info--da7b9";
export var slide = "provider-profile-slider-module--slide--a2941";
export var slideLeft = "provider-profile-slider-module--slideLeft--b2a97";
export var sliderTrack = "provider-profile-slider-module--sliderTrack--9478e";
export var sliderWrapper = "provider-profile-slider-module--sliderWrapper--59a93";